import { render } from "./CheckboxInput.vue?vue&type=template&id=349b79ca&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"

import "./CheckboxInput.vue?vue&type=style&index=0&id=349b79ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-349b79ca"

export default script